import { egImg } from "./exampleImg";

export const mockEncounter01 = {
  "status": "seen",
  "createdByName": "Ariadne Johnson",
  "actingAsName": "Joe Smith",
  "triageNurse": {
    "id": "CLN123",
    "firstName": "Joe",
    "lastName": "Smith"
  },
  "patient": {
    "firstName": "John",
    "lastName": "Johnson",
    "email": "john.johnson@email.com",
    "phone": "+61 7891234567",
    "id": "c81ce7ea-8934-4664-80f7-67950aad0e45",
    "dateOfBirth": "2000-01-31",
    "allergies": [
      {
        "description": "allergen 1",
        "severity": "mild",
        "source": "practitioner"
      },
      {
        "description": "allergen 2",
        "severity": "severe",
        "source": "practitioner"
      }
    ],
    "gender": "Male",
    "preferredName": "John",
    "medicareNo": "6123123111",
    "medicareNoPos": 1,
    "completedAdditionalQuestions": [
      "additionalQs.falls",
      "additionalQs.socialHist",
      "additionalQs.medHist"
    ],
    "smokeStatus": 1,
    "smoker": false
  },
  "healthHistory": [
    {
      "type": "immunological",
      "details": "anaemia"
    },
    {
      "type": "neurological",
      "details": "stroke"
    },
    {
      "type": "cancer",
      "details": "cured, bladder, bowel-colon"
    },
    {
      "type": "endocrine",
      "details": "diabetes-type-1"
    },
    {
      "type": "intestinal",
      "details": "stomach-ulcer, irritable-bowel-syndrome"
    },
    {
      "type": "cardiac",
      "details": "fibrillation, pacemaker"
    },
    {
      "type": "renal",
      "details": "kidney-failure-dialysis, urinary-tract-infections"
    },
    {
      "type": "hepatic",
      "details": "hepatitis, liver-cirrhosis"
    },
    {
      "type": "respiratory",
      "details": "copd, sleep-apnoea"
    },
    {
      "type": "psychiatric",
      "details": "other-mens-health-problems"
    },
    {
      "type": "musculoskeletal",
      "details": "osteoarthritis"
    },
    {
      "type": "hematological",
      "details": "aortic-aneurysm, peripheral-vascular-disease"
    },
    {
      "type": "dermatological",
      "details": "psoriasis"
    },
    {
      "type": "mens-health",
      "details": "other-mens-health-problems"
    }
  ],
  "regularMeds": "moreThan3",
  "fallRisk": {
    "fallenInLastYear": true,
    "feelUnsteady": true,
    "worriedAboutFalling": true
  },
  "recreationalDrugs": "yes",
  "alcoholConsumption": "less_than_one",
  "tobaccoConsumption": "ex_smoker",
  "homeSupport": "independent",
  "homeStatus": "with_family",
  "previousOperations": [
    {
      "type": "appendectomy",
      "when": "lt1month"
    },
    {
      "type": "knee_replacement",
      "when": "lt6months"
    },
    {
      "type": "cataract_surgery",
      "when": "gt6months"
    },
    {
      "type": "vasectomy",
      "when": "lt6months"
    }
  ],
  "employmentStatus": "unpaid_work",
  "healthcareDirective": "yes",
  "infectiousSymptoms": [
    // turn into screeningInfectionRisks after title casing everything
    "cough"
  ],
  "photos": [
    {
      type: "problem",
      data: egImg,
    },
    {
      type: "patient",
      data: egImg,
    }
  ],
  "obsNotRequired": false,
  "problem": {
    "patient": "Routine health assessment and monitoring with severe lower abdominal pain over the previous 24 hours.",
    "triage": "Patient reports progressive abdominal pain with intermittent nausea and reduced oral intake.",
    "nursingAssessment": "Escalate for urgent medical review, monitor pain and hydration status, and repeat full observations in 15 minutes."
  },
  "complaintCode": "DC000",
  "modeOfArrival": "ambulance_transfer_long_code",
  "location": {
    "id": "zone-red-bed-12",
    "name": "Resuscitation Zone - Bay 12 (Extended Observation Area)",
    "shortName": "Resus Bay 12"
  },
  "admittingSpecialty": "General Medicine and Acute Internal Care",
  "bedSlipSubmitted": "yes",
  "triageDirection": "urgent_review_required",
  "patientOrigin": "from_residential_care_with_support_team",
  "referrerDetails": {
    "from": "Perth Metro Transfer Liaison Service",
    "contactName": "Dr Emilia Patterson",
    "contactNumber": "+61 412 000 999"
  },
  "arrived": 1701708436751,
  "nextObsDue": 1702551337800,
  "source": "patient",
  "tasks": [
    {
      "type": "Medications",
      "status": "done",
      "history": [
        {
          "toStatus": "done",
          "fromStatus": "requested",
          "when": "2023-12-14T08:43:54.366Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "requested",
          "fromStatus": "done",
          "when": "2023-12-14T08:43:51.628Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "done",
          "fromStatus": "requested",
          "when": "2023-12-14T08:43:49.955Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "requested",
          "fromStatus": "not_requested",
          "when": "2023-12-14T08:42:42.698Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        }
      ]
    },
    {
      "type": "Blood Test",
      "status": "not_requested"
    },
    {
      "type": "ECG",
      "status": "not_requested"
    },
    {
      "type": "Urine Test",
      "status": "done",
      "history": [
        {
          "toStatus": "done",
          "fromStatus": "requested",
          "when": "2023-12-14T08:43:46.518Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "requested",
          "fromStatus": "not_requested",
          "when": "2023-12-14T08:42:27.555Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        }
      ]
    },
    {
      "type": "Pregnancy Test",
      "status": "requested",
      "history": [
        {
          "toStatus": "requested",
          "fromStatus": "done",
          "when": "2023-12-14T08:43:54.366Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "done",
          "fromStatus": "requested",
          "when": "2023-12-14T08:43:51.628Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "requested",
          "fromStatus": "done",
          "when": "2023-12-14T08:43:49.955Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "done",
          "fromStatus": "requested",
          "when": "2023-12-14T08:43:48.243Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "requested",
          "fromStatus": "not_requested",
          "when": "2023-12-14T08:42:29.251Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        }
      ]
    },
    {
      "type": "X-Ray",
      "status": "not_requested"
    },
    {
      "type": "Ultrasound",
      "status": "not_requested"
    },
    {
      "type": "CT Scan",
      "status": "not_requested"
    },
    {
      "type": "RAT Consult",
      "status": "requested",
      "history": [
        {
          "toStatus": "requested",
          "fromStatus": "done",
          "when": "2023-12-14T08:43:54.366Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "done",
          "fromStatus": "requested",
          "when": "2023-12-14T08:43:52.507Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        },
        {
          "toStatus": "requested",
          "fromStatus": "not_requested",
          "when": "2023-12-14T08:43:51.628Z",
          "userId": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
          "userName": "Robert Patterson"
        }
      ]
    }
  ],
  "patient_dob": 949276800000,
  "created": "2023-12-04T16:47:17.315Z",
  "lastModified": "2023-12-14T09:55:38.032Z",
  "id": "3be33336-751d-436f-886f-1d7b1d4d162e",
  "pain": 0,
  "frailty": 5,
  "activities": [
    {
      "id": "54654002-eeab-43ce-aeb5-8a7c5d045ac5",
      "text": "Added Severe peanut allergy",
      "type": "allergy",
      "createdByName": "Paul Pickles",
      "createdBy": "34a4b896-6144-4a34-ad69-cadc0b6b2e7d",
      "createdByRole": "other",
      "created": "2023-12-04T16:48:33.689Z"
    },
    {
      "id": "42b37c10-51c4-406a-aa60-4aa95287986c",
      "text": "Added mild allergen 1 allergy",
      "type": "allergy",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:41:54.553Z"
    },
    {
      "id": "2c47a2c5-c9c3-495a-bba9-8efad0e1a39e",
      "text": "Added severe allergen 2 allergy",
      "type": "allergy",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:42:03.771Z"
    },
    {
      "id": "9dcd53bd-f538-42cc-a38a-27976327606b",
      "text": "Set activity Urine Test to Requested",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:42:27.554Z"
    },
    {
      "id": "3727599d-da1d-4ad0-81f8-c89aec6e76a1",
      "text": "Set activity Pregnancy Test to Requested",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:42:29.251Z"
    },
    {
      "id": "c994de30-2438-4855-ab88-6fa261d719db",
      "text": "Set activity Medications to Requested",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:42:42.698Z"
    },
    {
      "id": "5e2a44f5-ddac-4f7e-aa96-d62e58805704",
      "text": "Set activity Urine Test to Done",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:43:46.518Z"
    },
    {
      "id": "601fad0e-35f3-497e-b6d7-94533a20635d",
      "text": "Set activity Pregnancy Test to Done",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:43:48.243Z"
    },
    {
      "id": "5a63d2f0-2c55-4453-8abe-80664ac29381",
      "text": "Set activity Medications to Done\nSet activity Pregnancy Test to Requested",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:43:49.955Z"
    },
    {
      "id": "a2c3ab75-3e5c-4965-b328-a68d02d2406d",
      "text": "Set activity Medications to Requested\nSet activity Pregnancy Test to Done\nSet activity RAT Consult to Requested",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:43:51.628Z"
    },
    {
      "id": "6afc4297-38e3-40c1-8810-ebead3e48966",
      "text": "Set activity RAT Consult to Done",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:43:52.507Z"
    },
    {
      "id": "9b019255-692d-42c2-853b-cf80e640599e",
      "text": "Set activity Medications to Done\nSet activity Pregnancy Test to Requested\nSet activity RAT Consult to Requested",
      "type": "tasks",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "created": "2023-12-14T08:43:54.366Z"
    }
  ],
  "notes": [
    {
      "id": "befe1408-4ca2-4016-a713-91bb8dce417d",
      "created": "2023-12-04T16:57:05.209Z",
      "lastModified": "2023-12-04T16:57:05.209Z",
      "text": "Please wait in the waiting room. The doctor will see you shortly.",
      "type": "communication",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "4aac8b14-9d38-446a-b0b3-bc690f84c8d0",
      "text": "Patient assessment completed. All vitals recorded and reviewed.",
      "lastModified": "2023-12-04T16:58:19.656Z",
      "created": "2023-12-04T16:58:19.656Z",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "55d98682-5dd2-464b-a041-158ec4d6685f",
      "text": "Patient seen with note: Initial consultation completed successfully",
      "lastModified": "2023-12-04T16:58:41.064Z",
      "created": "2023-12-04T16:58:41.064Z",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "dc55782b-daa4-40ff-ac3d-8383ae659c54",
      "created": "2023-12-04T16:58:45.431Z",
      "lastModified": "2023-12-04T16:58:45.431Z",
      "text": "Nursing assessment completed. Patient stable and comfortable.",
      "role": "nurse",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "5f0bdad6-d0bb-463b-88c9-08bc606e9f1f",
      "text": "Patient seen with note: Follow-up care plan discussed and documented",
      "lastModified": "2023-12-04T16:59:03.095Z",
      "created": "2023-12-04T16:59:03.095Z",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "99cd300e-3241-4d94-be4c-65f8ecfd18fe",
      "created": "2023-12-04T17:05:08.292Z",
      "lastModified": "2023-12-04T17:05:08.292Z",
      "text": "Please approach the front desk.",
      "type": "communication",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "5abae0a4-68b4-4ac9-803c-cf524728ffed",
      "created": "2023-12-14T08:41:02.803Z",
      "lastModified": "2023-12-14T08:41:02.803Z",
      "text": "Patient monitoring continues. All observations within normal parameters.",
      "role": "nurse",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "f7b9883c-7b9c-42d7-bcd3-07a6bf765571",
      "created": "2023-12-14T08:41:32.475Z",
      "lastModified": "2023-12-14T08:41:32.475Z",
      "text": "This is a comprehensive nursing assessment note. Patient appears comfortable and responsive to treatment. Vital signs monitored regularly. Family members have been updated on patient's condition and care plan. Continuing with prescribed medication regimen.",
      "role": "nurse",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    }
  ],
  "distressed": false,
  "lastDistress": "2023-12-04T16:58:10.278Z",
  "seen": 1701709143095,
  "observations": [
    {
      "id": "2494b3b4-cc34-4f94-96fc-c8e58dd819b9",
      "created": "2023-12-13T15:26:22.164Z",
      "lastModified": "2023-12-13T15:26:22.164Z",
      "respirations": 18,
      "o2Sats": 99,
      "o2Flow": 6,
      "heartRate": 90,
      "hypercapnicRespiratoryFailure": false,
      "bloodPressure": {
        "diastolic": 110,
        "systolic": 140
      },
      "temperature": 34,
      "consciousness": "A",
      "rhythm": "Regular",
      "painScore": 2,
      "bloodGlucose": 1,
      "bloodAlcohol": 0,
      "note": " Robert Patterson acknowledged the escalation process",
      "bedside": {
        "bloodPressure": {
          "leftArm": {
            "systolic": 110,
            "diastolic": 80
          },
          "rightArm": {
            "systolic": 110,
            "diastolic": 80
          },
          "laying": {
            "systolic": 110,
            "diastolic": 80
          },
          "standing": {
            "systolic": 110,
            "diastolic": 80
          }
        },
        "heartRate": 90
      },
      "ventilator": {
        "tidalVolume": 5,
        "minuteVentilation": 5,
        "frequencyRate": 5,
        "peakPressure": 5,
        "endTidalCarbonDioxide": 5
      },
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "252eaf3a-aa89-45bf-b2dd-9df2e67cdcff",
      "created": "2023-12-13T15:54:48.792Z",
      "lastModified": "2023-12-13T15:54:48.792Z",
      "respirations": 24,
      "o2Sats": 98,
      "o2Flow": 6,
      "heartRate": 90,
      "hypercapnicRespiratoryFailure": false,
      "bloodPressure": {
        "diastolic": 140,
        "systolic": 160
      },
      "temperature": 38,
      "consciousness": "A",
      "rhythm": "Regular",
      "painScore": 5,
      "bloodGlucose": 1,
      "bloodAlcohol": 0,
      "note": " Robert Patterson acknowledged the escalation process",
      "bedside": {
        "bloodPressure": {
          "leftArm": {
            "systolic": 110,
            "diastolic": 80
          },
          "rightArm": {
            "systolic": 110,
            "diastolic": 80
          },
          "laying": {
            "systolic": 110,
            "diastolic": 80
          },
          "standing": {
            "systolic": 110,
            "diastolic": 80
          }
        },
        "heartRate": 90
      },
      "ventilator": {
        "tidalVolume": 1,
        "minuteVentilation": 1,
        "frequencyRate": 1,
        "peakPressure": 1,
        "endTidalCarbonDioxide": 1
      },
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "6cd2d714-5ecd-456c-b4b0-5619f5ec0fc6",
      "created": "2023-12-14T08:43:17.225Z",
      "lastModified": "2023-12-14T08:43:17.225Z",
      "urinalysis": {
        "distream": "Yes",
        "abnormalities": "Yes",
        "glucose": "++",
        "protein": "+",
        "blood": "++",
        "bilirubin": "Negative",
        "nitrite": "Negative",
        "urobilinogen": "++",
        "leukocytes": "+",
        "ph": "7.5",
        "ketone": "Trace",
        "specificGravity": "1.020"
      },
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "a23c092b-782d-4113-9123-4259b6183667",
      "created": "2023-12-14T08:43:31.613Z",
      "lastModified": "2023-12-14T08:43:31.613Z",
      "urinalysis": {
        "pregnancy": "Negative"
      },
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "282b81b6-68b5-453a-a40b-92bafae7c23a",
      "created": "2023-12-14T08:47:34.918Z",
      "lastModified": "2023-12-14T08:47:34.918Z",
      "respirations": 4,
      "o2Sats": 84,
      "o2Flow": 2,
      "heartRate": 30,
      "hypercapnicRespiratoryFailure": false,
      "bloodPressure": {
        "diastolic": 40,
        "systolic": 50
      },
      "temperature": 35,
      "consciousness": "U",
      "rhythm": "A Flut - Atrial Flutter",
      "painScore": 3,
      "bloodGlucose": 1,
      "bloodAlcohol": 2,
      "note": " Robert Patterson acknowledged the escalation process",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other"
    },
    {
      "id": "12ed819b-0608-41de-a587-0d5756a55bc1",
      "created": "2023-12-14T08:52:18.444Z",
      "lastModified": "2023-12-14T08:52:18.444Z",
      "respirations": 36,
      "o2Sats": 94,
      "o2Flow": 10,
      "heartRate": 140,
      "hypercapnicRespiratoryFailure": true,
      "bloodPressure": {
        "diastolic": 190,
        "systolic": 220
      },
      "temperature": 39,
      "consciousness": "A",
      "rhythm": "SR - Sinus Rhythm",
      "painScore": 1,
      "bloodGlucose": 3,
      "bloodAlcohol": 2,
      "note": " Robert Patterson acknowledged the escalation process",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "riskScore": {
        "score": 5,
        "risk": 3,
        "incomplete": false
      },
    },
    {
      "id": "ventilator-only-obs-001",
      "created": "2023-12-14T09:50:00.000Z",
      "lastModified": "2023-12-14T09:50:00.000Z",
      "ventilator": {
        "tidalVolume": 450,
        "minuteVentilation": 8.5,
        "frequencyRate": 12,
        "peakPressure": 25,
        "endTidalCarbonDioxide": 35
      },
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "riskScore": {
        "score": 0,
        "risk": 0,
        "incomplete": true
      },
    },
    {
      "id": "44337adc-b887-4afd-884e-c20f137a00f1",
      "created": "2023-12-14T09:55:37.665Z",
      "lastModified": "2023-12-14T09:55:37.665Z",
      "respirations": 20,
      "o2Sats": 85,
      "o2Flow": 0,
      "heartRate": 90,
      "hypercapnicRespiratoryFailure": false,
      "bloodPressure": {
        "diastolic": 80,
        "systolic": 120
      },
      "temperature": 37,
      "consciousness": "V",
      "rhythm": "3°HB - Third-degree Heart Block",
      "painScore": 4,
      "bloodGlucose": 1,
      "bloodAlcohol": 2,
      "note": " Robert Patterson acknowledged the escalation process",
      "createdByName": "Robert Patterson",
      "createdBy": "96f124f2-65a4-4a4d-9c15-2925929e0a8e",
      "createdByRole": "other",
      "riskScore": {
        "score": 8,
        "risk": 3,
        "incomplete": false
      },
    }
  ],
  "riskScore": {
    "score": 8,
    "risk": 3,
    "incomplete": false
  }
};
